export { MB_Tags } from './src/MB_Tags';
export type { MB_TagsRef } from './src/MB_Tags';
export type { MB_Tag } from './src/types';
import searchUtils from './src/searchUtils';
const mbTagSearch = searchUtils.tagSearch;
export { mbTagSearch };
